/**
 * This file should contain foundational javascript that is needed globally.
 */
import { datadogLogs } from "@datadog/browser-logs";

try {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });
} catch (error) {
  datadogLogs.logger.error('ajaxSetup Error', {}, error);
}

import 'bootstrap/js/dist/collapse';
import 'bootstrap-confirmation2/dist/bootstrap-confirmation.js';
import 'jquery-match-height';
import { Cookie } from './classes/cookie';
import { EqualHeight } from './classes/equal-height';
import { NavBar } from './classes/navbar';
import Vue from 'vue';
import Axios from 'axios';
import axios from 'axios';
import VueAxios from 'vue-axios';
import FeatureFlags from '@js/plugins/featureFlags';
import DatadogLogs from '@js/plugins/datadogLogs';
import { datadogRum } from '@datadog/browser-rum';
import * as braze from "@braze/web-sdk";
import './consent-manager.js';

Vue.use(FeatureFlags);
Vue.use(VueAxios, Axios);

if (window.pwcc.config.DATADOG_RUM_CLIENT_TOKEN && window.pwcc.config.DATADOG_RUM_APPLICATION_ID) {
  const initDatadogRum = () => {
    if (window.consentManager && window.DataGrailCategory) {
      window.consentManager.ifConsent(window.DataGrailCategory.PERFORMANCE, () => {
        try {
          datadogRum.init({
            applicationId: window.pwcc.config.DATADOG_RUM_APPLICATION_ID,
            clientToken: window.pwcc.config.DATADOG_RUM_CLIENT_TOKEN,
            site: window.pwcc.config.DATADOG_RUM_SITE,
            service: window.pwcc.config.DATADOG_RUM_SERVICE,
            version: window.pwcc.config.DD_VERSION,
            env: window.pwcc.config.DATADOG_RUM_ENV,
            sessionSampleRate: window.pwcc.config.DATADOG_RUM_SESSION_SAMPLE_RATE,
            sessionReplaySampleRate: window.pwcc.config.DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE,
            trackResources: window.pwcc.config.DATADOG_RUM_TRACK_RESOURCES,
            trackLongTasks: window.pwcc.config.DATADOG_RUM_TRACK_LONG_TASKS,
            trackUserInteractions: window.pwcc.config.DATADOG_RUM_TRACK_USER_INTRACTIONS,
          });
          console.log("✅ Datadog RUM init completed successfully");
        } catch (error) {
          console.error("❌ Datadog RUM init failed:", error);
        }
      });
    } else {
      setTimeout(initDatadogRum, 100);
    }
  };
  
  initDatadogRum();
}

// Initialize DatadogLogs Vue plugin with consent checking
const initDatadogLogs = () => {
  if (window.consentManager && window.DataGrailCategory) {
    console.log("🔍 Initializing DatadogLogs with consent check");
    window.consentManager.ifConsent(window.DataGrailCategory.PERFORMANCE, () => {
      console.log("📊 DATADOG LOGS INITIALIZED - CONSENT GRANTED");
      try {
        if (typeof Vue !== 'undefined') {
          Vue.use(DatadogLogs);
          console.log("✅ DatadogLogs Vue plugin installed successfully");
        } else {
          console.error("❌ Vue is not available for DatadogLogs plugin");
        }
      } catch (error) {
        console.error("❌ Error installing DatadogLogs Vue plugin:", error);
      }
    });
  } else {
    console.log("⏳ Waiting for consent manager to be available for DatadogLogs");
    setTimeout(initDatadogLogs, 100);
  }
};

initDatadogLogs();

if (window.pwcc.config.BRAZE_API_KEY && window.pwcc.config.BRAZE_SDK_BASE_URL && jsConfig.nav.profile !== null) {
  // Wait for consent manager to be available
  const initBraze = () => {
    if (window.consentManager && window.DataGrailCategory) {
      // Check if marketing consent is granted before initializing Braze
      window.consentManager.ifConsent(window.DataGrailCategory.MARKETING, () => {
        console.log("🔥 BRAZE INITIALIZED - CONSENT GRANTED");
        try {
          braze.initialize(window.pwcc.config.BRAZE_API_KEY, {
            baseUrl: window.pwcc.config.BRAZE_SDK_BASE_URL
          });
        
          const profile = jsConfig.nav.profile;
          braze.changeUser(profile.tenant_id);
          const user = braze.getUser();
          user.setEmail(profile.email);

          // Open a new session on Braze to track the user's session
          braze.openSession();
        } catch (error) {
          datadogLogs.logger.error('Braze Setup Error', {}, error);
        }
      });
    } else {
      // Retry after a short delay
      setTimeout(initBraze, 100);
    }
  };
  
  initBraze();
}

window._tippyConfig = {
  allowHTML: true,
  theme: 'light',
  animation: 'perspective',
  arrow: true,
  delay: [0, 500],
  interactive: true,
  interactiveBorder: 5
};

window._token = document.head.querySelector('meta[name="csrf-token"]');

window.addEventListener('touchstart', function onFirstTouch() {
  document.body.classList.add('user-is-touching');
  window._userIsTouching = true;
  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    datadogLogs.logger.error('Axios Intercepted Error', {}, error);
    return Promise.reject(error);
  }
);

jQuery(() => {

  const cookie = new Cookie();
  const equalHeight = new EqualHeight();
  const navBar = new NavBar();
  const $iq = $('input[type=search][name=q]');
  const iqValue = $iq.val();
  const $modalShow = $('.modal.show-on-load');
  const $searchIcon = $('.search i.search-icon');

  toastr.options = {
    positionClass: 'toast-bottom-right',
    showMethod: 'slideDown',
    hideMethod: 'slideUp',
    closeMethod: 'slideUp',
    newestOnTop: false,
    iconClasses: {
      success: 'toast-success',
      error: 'toast-error',
      info: 'toast-info',
      warning: 'toast-none'
    }
  };

  tippy('.tippy', window._tippyConfig);

  $('[data-toggle=confirmation]').confirmation({
    rootSelector: '[data-toggle=confirmation]',
    btnOkLabel: 'Confirm',
    btnOkClass: 'btn btn-sm btn-primary rounded mr-2',
    btnCancelLabel: 'Cancel',
    btnCancelClass: 'btn btn-sm btn-default rounded ml-2',
    popout: true
  });

  $('.custom-file-input').on('change', e => {
    const $this = $(e.currentTarget);
    const fileName = $this.val().split('\\').pop();

    $this.next('.custom-file-label').html(fileName);
  });

  $('.btn-search-clear').click(e => {
    const $currentTarget = $(e.currentTarget);

    $currentTarget.siblings('input[name=q]').val('').focus();
    $currentTarget.addClass('d-none');
  });

  $modalShow.modal('show');

  $iq
    .keyup(e => {
      if ($(e.currentTarget).val() !== '') {
        $('.btn-search-clear').removeClass('d-none');
      } else {
        $('.btn-search-clear').addClass('d-none');
      }
    })
    .closest('form')
    .submit(() => {
      if ($iq.val() !== iqValue) {
        $('#page-select').val(1);
      }

      return true;
    });

  $searchIcon.on('click', e => {
    $iq
      .closest('form')
      .submit();
  });

});

window.sendEvent = (label, event = 'consign', category = 'download') => {
  gtag('event', event, {
    'event_category': category,
    'event_label': label
  });
};

window.openLoginForm = (redirectUrl) => {
  const detail = {
    type: 'open-login'
  };

  if (redirectUrl) {
    detail.redirectUrl = redirectUrl;
  }

  window.dispatchEvent(new CustomEvent('common-components:action', { detail }));
};
